import * as _ from 'lodash'
import { StoreExt } from '@utils/reactExt'
import { Pushwoosh } from 'web-push-notifications'

export class PushwooshStore extends StoreExt {

  pushwoosh: Pushwoosh

  constructor() {
    super()

    this.pushwoosh = new Pushwoosh()
    window.pushwoosh = this.pushwoosh
  }

  getIsSubScribed = async (): Promise<boolean> => {
    if (!this.pushwoosh) {
      return false
    }

    return this.pushwoosh.isSubscribed()
  }

  getHWID = async (): Promise<string> => {
    return this.pushwoosh.getHWID()
  }

  fetchPushwooshInfoFromIndexedDb = async (): Promise<any[]> => {
    return new Promise((resolve, reject) => {
      const dbOpen = window.indexedDB.open('PUSHWOOSH_SDK_STORE')

      dbOpen.onsuccess = () => {
        const pushwooshDb = dbOpen.result

        const fetch = pushwooshDb
          .transaction('keyValue', 'readonly')
          .objectStore('keyValue')
          .getAll()

        fetch.onsuccess = () => {
          resolve(fetch.result)
        }

        fetch.onerror = () => {
          reject('IndexedDb Data Fatch Fail')
        }
      }

      dbOpen.onerror = () => {
        reject('IndexedDb Open Fail')
      }
    })
  }

  registerUserHWID = async (): Promise<void> => {

    const isSubscribed = await this.getIsSubScribed()

    if (!isSubscribed) {
      return
    }

    const hwid = await this.getHWID()

    if (_.isEmpty(hwid)) {
      return
    }

    const pushwooshInfo = await this.fetchPushwooshInfoFromIndexedDb()

    if (!pushwooshInfo) {
      return
    }

    this.api.component.registerPushwooshInfo({
      hwid,
      pushwooshInfo: JSON.stringify(pushwooshInfo)
    })
  }
}

export default new PushwooshStore()
